import * as React from "react";
import { SVGProps } from "react";
const SvgPages = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26 2H6c-1.1 0-2 .9-2 2v24c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Zm0 26H9V4h17v24ZM12 9h11v2H12V9Zm0 6h11v2H12v-2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPages;
